// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Select from "./Select.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";

function InputSelectField(props) {
  let onChange = props.onChange;
  return JsxRuntime.jsx(Select.make, {
    label: props.label,
    placeholder: props.placeholder,
    preset: {
      NAME: "inputField",
      VAL: {
        required: Stdlib_Option.getOr(props.required, false),
        tooltip: props.tooltip,
        errorMessage: props.errorMessage
      }
    },
    searchable: props.searchable,
    disabled: props.disabled,
    renderValue: props.renderValue,
    renderItem: props.renderItem,
    sections: props.sections,
    value: {
      TAG: "Single",
      _0: props.value
    },
    onChange: change => {
      if (change.TAG === "Single") {
        return onChange(change._0);
      }
    }
  });
}

let make = InputSelectField;

export {
  make,
}
/* Select Not a pure module */
